import React, { useContext } from 'react'

import { PropertyCardContext } from '../property-card.context'
import * as S from './styled'

const Toast = () => {
  const { isPartner, property } = useContext(PropertyCardContext)

  if (isPartner) return <S.PartnerToast>Unidade parceira</S.PartnerToast>

  if (property?.building?.flagship)
    return <S.FlagshipToast>Prédio Housi</S.FlagshipToast>

  return null
}

export default Toast
